import { ReactElement, useCallback } from 'react';

import { ChevronRightIcon, Link, StyledFlex, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { patientPaths } from '~libs.desktop.shared.paths';

import { patientConsentsAndAuthorizationsTranslationKeys, visitTranslationKeys } from '../../translations';

type PatientConsentsAndAuthorizationsSidePanelLinkProps = {
   readonly patientId: number;
};

export const PatientConsentsAndAuthorizationsSidePanelLink = (
   props: PatientConsentsAndAuthorizationsSidePanelLinkProps
): ReactElement => {
   const push = useHistoryPushWithBackAction(true);

   const goToPatientConsentsAndAuthorizations = useCallback(
      () =>
         push(patientPaths.getConsentsAndAuthorizationsPath(props.patientId), {
            label: visitTranslationKeys.goBackToVisit,
         }),
      [push, props.patientId]
   );

   return (
      <StyledFlex justifyContent={'flex-end'}>
         <Link
            testId={'goToPatientConsentsAndAuthorizations'}
            iconSuffix={<ChevronRightIcon />}
            label={patientConsentsAndAuthorizationsTranslationKeys.actions.goToPatientConsentsAndAuthorizations}
            onClick={goToPatientConsentsAndAuthorizations}
         />
      </StyledFlex>
   );
};
